



















import mixins from 'vue-typed-mixins';
import RoleForm from '@/components/role/RoleForm.vue';
import RoleUtils, { Role } from '../../utils/RoleUtils';
export default mixins().extend({
  components: {
    RoleForm,
  },
  data(): {
    role: Role;
  } {
    return {
      role: {
        name: this.$languageobj(),
        permissions: {},
      },
    };
  },
  methods: {
    async submit() {
      try {
        this.$alert.hide('submit');

        await RoleUtils.api.add(this.role);
        await this.$router.push({ name: 'role' });

        this.$toast.push({
          type: 'success',
          text: this.$languageobj('validation.success.add', {
            values: [this.role.name],
          }),
        });
      } catch (error) {
        this.$alert.show('submit', {
          type: 'error',
          messages: this.$handleAPIError(error, this.$refs.observer),
        });
      }
    },
  },
});
